<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-2 lbl">
          <label>Genre: </label>
        </div>
        <div class="col-4">
          <Dropdown v-model="genre"
                    :options="genreLibelles" optionValue="valeur"
                    optionLabel="texte" scrollHeight="205px" :showClear="true"/>
        </div>
      </div>
      <div class="row">
        <div class="col-2 lbl">
          <label>Nature: </label>
        </div>
        <div class="col-4">
          <Dropdown v-model="nature"
                    :options="natureLibelles" optionValue="valeur"
                    optionLabel="texte" scrollHeight="205px" :showClear="true"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-2 lbl">
      <label>Sous-categories :</label>
    </div>
    <div class="col">
      <vue-list-picker title-left="Sous-categories disponibles" title-right="Sous-categories choisis"
                       :left-items="leftSousCategorieDisponibles" :right-items="rightSousCategorieChoisis"
                       :content-substr=100 title-class="lbl text-vertical-center"/>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import {mapGetters} from 'vuex';
import {VueListPicker} from 'vue-list-picker';

export default {
  name: 'ModifierChampsSousCategorie',
  props: ['isModifier'],
  components: {
    VueListPicker
  },
  data() {
    return {
      leftSousCategorieDisponibles: [],
      rightSousCategorieChoisis: [],
      sousCategorieChoisis: [],
      genreLibelles: [],
      natureLibelles: [],
      genre: null,
      nature: null,
      listSousCategorie: [],
    };
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      dossier: 'dossier/dossier',
      listeSousCategorie: 'sousCategorie/listeSousCategorie',
    })
  },
  beforeMount() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.genre = this.dossier.genre;
    this.nature = this.dossier.nature;
    this.setGenreEtNature();
  },
  methods: {
    getSousCategorieLocal() {
      this.listSousCategorie =  [];
      for (let i = 0; i < this.rightSousCategorieChoisis.length; i++) {
        this.listSousCategorie.push({
          sousCategorie: this.rightSousCategorieChoisis[i].key,
          sousCategorieAfficher: this.rightSousCategorieChoisis[i].content,
          cle: this.dossier.cle,
          site: this.dossier.site,
        });
      }
      return this.listSousCategorie;
    },
    getAncienSousCategorie() {
      if (this.getNewSousCategorieLocal().length == 0  && this.getSousCategorieASupprimer().length == 0)
        return this.listSousCategorie;
      let liste = [];
      let listAncienSousCategorie =  [];
      Object.values(this.listeSousCategorie).forEach(sc => {
        listAncienSousCategorie.push(sc)
      });
      for (let i = 0; i < listAncienSousCategorie.length; i++) {
        liste.push({
          sousCategorie: listAncienSousCategorie[i].sousCategorie,
          sousCategorieAfficher: listAncienSousCategorie[i].sousCategorieAfficher,
          cle: this.dossier.cle,
          site: this.dossier.site,
        });
      }
      return liste;
    },
    getNewSousCategorieLocal() {
      let newSousCategorieLocal = [];
      if (this.rightSousCategorieChoisis.length == 0)
        return newSousCategorieLocal;
      Object.values(this.listeSousCategorie).forEach(sc => {
        newSousCategorieLocal.push(sc)
      });
      newSousCategorieLocal = this.rightSousCategorieChoisis.filter(ar =>
          !newSousCategorieLocal.find(rm => (rm.sousCategorie === ar.key))
      );
      for (let i = 0; i < newSousCategorieLocal.length; i++) {
        newSousCategorieLocal[i].cle = this.dossier.cle;
        newSousCategorieLocal[i].site = this.dossier.site;
        newSousCategorieLocal[i].sousCategorie = newSousCategorieLocal[i].key;
        newSousCategorieLocal[i].sousCategorieAfficher = newSousCategorieLocal[i].content;
      }
      return newSousCategorieLocal;
    },
    getSousCategorieASupprimer() {
      let sousCategorieASupprimer = [];
      Object.values(this.listeSousCategorie).forEach(sc => {
        sousCategorieASupprimer.push(sc)
      });
      sousCategorieASupprimer = sousCategorieASupprimer.filter(ar =>
        !this.rightSousCategorieChoisis.find(rm => (rm.key === ar.sousCategorie)));
      return sousCategorieASupprimer;
    },
    setListeSousCategorie(currentSousCategorie) {
      if (this.isModifier) {
        Object.values(currentSousCategorie).forEach(sc => {
          this.sousCategorieChoisis.push(sc)
        });
        for (let i = 0; i < this.sousCategorieChoisis.length; i++) {
          this.rightSousCategorieChoisis.push({
            key: this.sousCategorieChoisis[i].sousCategorie,
            content: this.sousCategorieChoisis[i].sousCategorieAfficher
          });
        }
        this.sousCategorieDisponibles = this.sousCategorieDisponibles?.filter(
            sc => !this.sousCategorieChoisis.find(rm => (rm.sousCategorie === sc.valeur)));
      }
      this.setLeftListe();
    },
    setGenreEtNature() {
      this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
        libelleChange: 'Genre',
        nouvelleValeur: this.dossier.entite
      })
          .then((res) => {
            this.genreLibelles = res.data;
          });
      this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
        libelleChange: 'Nature',
        nouvelleValeur: this.genre
      })
          .then((res) => {
            this.natureLibelles = res.data;
          });
      this.setListeSousCategorie(this.listeSousCategorie);
    },
    setLeftListe() {
      let categorieDossier = [];
      categorieDossier.push(this.dossier.categorie);
      this.sousCategorieDisponibles = this.sousCategorieDisponibles?.filter(
          sc => !categorieDossier.find(rm => (rm === sc.valeur)));
      for (let i = 0; i < this.sousCategorieDisponibles?.length; i++) {
        this.leftSousCategorieDisponibles.push({
          key: this.sousCategorieDisponibles[i].valeur,
          content: this.sousCategorieDisponibles[i].texte
        });
      }
    },
  },
  watch: {
    'genre': function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Nature',
          nouvelleValeur: val
        })
            .then((res) => {
              this.natureLibelles = res.data;
              this.nature = null;
            });
      } else {
        this.nature = null;
        this.natureLibelles = [];
        this.leftSousCategorieDisponibles = [];
      }
    },
    'nature': function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('sousCategorie/obtenirListeSousCategorieDecisionLibelleAction', {
          action: 126,
          nature: val
        })
            .then((res) => {
              this.leftSousCategorieDisponibles = [];
              this.sousCategorieDisponibles = res.data;
              if (this.isModifier) {
                this.sousCategorieDisponibles = this.sousCategorieDisponibles?.filter(
                    sc => !this.sousCategorieChoisis.find(rm => (rm.sousCategorie === sc.valeur)));
                this.setLeftListe();
              }else{
                this.setLeftListe();
              }
            });
      } else {
        this.nature = null;
        this.leftSousCategorieDisponibles = [];
      }
    },
  }
}
</script>